import React from 'react';
import PropTypes from 'prop-types';

import DrawerMenu from '@/leftDrawer/DrawerMenu';
import DrawerTitle from '@/leftDrawer/DrawerTitle';

function LeftDrawer({
  menu,
  handleMenuChange,
  handleSubMenuChange,
  handleCollapseSubMenuChange,
  isDisplayingSearchResults,
  subMenuToOpenByIndex,
}) {
  return (
    <aside className="fixed top-0 left-0 bottom-0 w-[220px] overflow-x-hidden bg-[#1C3B5E] text-white z-[120] flex flex-col shadow-xl border-r border-[#143253] font-['Open_Sans']">
      <DrawerTitle />

      <div className="flex-1 flex flex-col overflow-y-auto custom-scrollbar pt-2">
        <DrawerMenu
          menu={menu}
          handleMenuChange={handleMenuChange}
          handleSubMenuChange={handleSubMenuChange}
          handleCollapseSubMenuChange={handleCollapseSubMenuChange}
          isDisplayingSearchResults={isDisplayingSearchResults}
          subMenuToOpenByIndex={subMenuToOpenByIndex}
        />
      </div>
    </aside>
  );
}

LeftDrawer.propTypes = {
  /**
   * Array with the menu options
   */
  menu: PropTypes.array.isRequired,
  /**
   * Function to handle the change of the menu
   */
  handleMenuChange: PropTypes.func.isRequired,
  /**
   * Function to handle the change of the sub-menu
   */
  handleSubMenuChange: PropTypes.func.isRequired,
  /**
   * Function to handle the url change of the collapse-menu (submenu inside submenu)
   */
  handleCollapseSubMenuChange: PropTypes.func.isRequired,
  /**
   * Is displaying search results list
   */
  isDisplayingSearchResults: PropTypes.bool,
  /**
   * Default submenu index to open (if it is provided)
   */
  subMenuToOpenByIndex: PropTypes.number,
};

LeftDrawer.defaultProps = {
  isDisplayingSearchResults: false,
  subMenuToOpenByIndex: null,
};

export default LeftDrawer;
